import { render } from "./NetworkersCard.vue?vue&type=template&id=64704992&scoped=true"
import script from "./NetworkersCard.vue?vue&type=script&lang=js"
export * from "./NetworkersCard.vue?vue&type=script&lang=js"

import "./NetworkersCard.vue?vue&type=style&index=0&id=64704992&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64704992"]])

export default __exports__